import React, { FC, memo } from "react";

import { ITask, TaskActionType } from "@/data/tasks";

import { DCCDetails } from "../DesignatedCandidateCreate/DCCDetails";
import { WOCDetails } from "../WorkOrderConfirm/WOCDetails";

export interface ITaskDetailsProps {
  task: ITask;
  refresh?: () => void;
  onAction?: (actionType: TaskActionType, comment: string, task: ITask) => void;
}

export const TaskDetails: FC<ITaskDetailsProps> = memo(({ task, refresh, onAction }) => {
  return task.type === "WO_CONFIRM" ? (
    <WOCDetails task={task} onAction={onAction} />
  ) : (
    <DCCDetails task={task} refresh={refresh} onAction={onAction} />
  );
});
